import { gql } from "@apollo/client";

export const GET_CLIENT_HUB_ZONE_LISTING = gql`
    query GetClientHubZoneListing(
        $filters: ClientHubZoneFiltersTypeInput,
        $pageRequest: PageRequestTypeInput
    ) {
        getClientHubZoneListing(filters: $filters, pageRequest: $pageRequest) {
            content {
                id
                channelId
                channelName
                hubId
                hubName
                zipcode
                zone
                activeTime
                operatorId
                createdAt
                updatedAt
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface ClientHubZoneType {
    id: number;
    channelId: number;
    channelName?: string;
    hubId: number;
    hubName?: string;
    zipcode: string;
    zone: string;
    activeTime?: number | null;
    operatorId: number;
    createdAt: number;
    updatedAt: number;
}

export interface ClientHubZoneFiltersTypeInput {
    channelId?: number;
    hubId?: number;
    zipcode?: string;
    zone?: string;
    activeTime?: {
        start?: string;
        end?: string;
    };
    operatorId?: number;
}

export interface PageRequestTypeInput {
    page?: number;
    size?: number;
    sortBy?: string;
    sortDirection?: 'ASC' | 'DESC';
}

export interface ClientHubZoneListingResponse {
    content: ClientHubZoneType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface GetClientHubZoneListingResponse {
    getClientHubZoneListing: ClientHubZoneListingResponse;
}

export interface GetClientHubZoneListingVariables {
    filters?: ClientHubZoneFiltersTypeInput;
    pageRequest?: PageRequestTypeInput;
}

